import { DatePickerPropsType } from './PropsType'

export let bridge: {
    setConfig?: (config: DatePickerPropsType) => any
  } = {}
  

export function showDatePicker(config: DatePickerPropsType): void {
    if (bridge.setConfig) {
        bridge.setConfig({
          ...config
        })
      }
}



// WEBPACK FOOTER //
// ../src/date-picker/bridge.ts